import { logEventAnalytics } from "./firebase/analytics";

export const MARKETING_SITE_URL = "https://gamevision.pro/";

export function openMarketingSite() {
    const url = MARKETING_SITE_URL;
    logEventAnalytics("download", { url });

    if (window.electron?.openExternal) {
        window.electron.openExternal(url);
    } else {
        window.location.href = url;
    }

    return true;
}

export async function openPrimaryDownload() {
    return openMarketingSite();
}
